import type { AppliedFilterItem } from '@modules/search/type/filter-state';
import type { FilterStates } from '@modules/magazine/type/filter-states';
import { DigitalMagazineOptions } from '@modules/magazine/configs/constants';

import dayjs from 'dayjs';

export const getAppliedFilters = (
    filterStates: FilterStates,
    resetFilters: (states: FilterStates, apply?: boolean) => void,
): AppliedFilterItem[] => {
    // category
    const category = DigitalMagazineOptions.find(
        (o) => o.searchEnum === filterStates.categoryEnum,
    );

    return [
        ...(category && category.searchEnum
            ? [
                  {
                      key: category.key,
                      label: category.label,
                      action: () => {
                          resetFilters(
                              {
                                  ...filterStates,
                                  categoryEnum: null,
                              },
                              true,
                          );
                      },
                  },
              ]
            : []),
        ...(filterStates.year
            ? [
                  {
                      key: 'dateRangeFilter',
                      label: `${filterStates.year}${
                          filterStates?.month
                              ? ` ${dayjs()
                                    .month(Math.max(filterStates.month - 1, 0))
                                    .format('MMMM')}`
                              : ''
                      }`,
                      action: () => {
                          resetFilters(
                              {
                                  ...filterStates,
                                  year: null,
                                  month: null,
                              },
                              true,
                          );
                      },
                  },
              ]
            : []),
    ];
};
